var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2992 9.62261C11.0817 9.62261 10.9061 9.79815 10.9061 10.0156V16.1572C10.9061 16.3747 11.0817 16.5503 11.2992 16.5503C11.5166 16.5503 11.6922 16.3747 11.6922 16.1572V10.0156C11.6922 9.79815 11.5166 9.62261 11.2992 9.62261Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3005 6.79285C11.083 6.79285 10.9074 6.9684 10.9074 7.18588V7.19767C10.9074 7.41514 11.083 7.58414 11.3005 7.58414C11.5179 7.58414 11.6935 7.40204 11.6935 7.18457C11.6935 6.96709 11.5179 6.79285 11.3005 6.79285Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2991 0.670898C5.23484 0.670898 0.299805 5.60593 0.299805 11.6702C0.299805 17.7346 5.23484 22.6696 11.2991 22.6696C17.3635 22.6696 22.2985 17.7346 22.2985 11.6702C22.2985 5.60593 17.3648 0.670898 11.2991 0.670898ZM11.2991 21.8849C5.66716 21.8849 1.08585 17.3035 1.08585 11.6716C1.08585 6.03956 5.66847 1.45694 11.2991 1.45694C16.9298 1.45694 21.5125 6.03825 21.5125 11.6702C21.5125 17.3022 16.9298 21.8835 11.2991 21.8835V21.8849Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2992 9.62261C11.0817 9.62261 10.9061 9.79815 10.9061 10.0156V16.1572C10.9061 16.3747 11.0817 16.5503 11.2992 16.5503C11.5166 16.5503 11.6922 16.3747 11.6922 16.1572V10.0156C11.6922 9.79815 11.5166 9.62261 11.2992 9.62261Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3005 6.79285C11.083 6.79285 10.9074 6.9684 10.9074 7.18588V7.19767C10.9074 7.41514 11.083 7.58414 11.3005 7.58414C11.5179 7.58414 11.6935 7.40204 11.6935 7.18457C11.6935 6.96709 11.5179 6.79285 11.3005 6.79285Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2991 0.670898C5.23484 0.670898 0.299805 5.60593 0.299805 11.6702C0.299805 17.7346 5.23484 22.6696 11.2991 22.6696C17.3635 22.6696 22.2985 17.7346 22.2985 11.6702C22.2985 5.60593 17.3648 0.670898 11.2991 0.670898ZM11.2991 21.8849C5.66716 21.8849 1.08585 17.3035 1.08585 11.6716C1.08585 6.03956 5.66847 1.45694 11.2991 1.45694C16.9298 1.45694 21.5125 6.03825 21.5125 11.6702C21.5125 17.3022 16.9298 21.8835 11.2991 21.8835V21.8849Z",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.4b511214abb1c71728ee4151efd3e558.svg";
export { ForwardRef as ReactComponent };